"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockZugentlastungen = void 0;
exports.mockZugentlastungen = [
    {
        Zaehne: 2,
        Laengeneingabe: false,
        ArtNrDE: '481.ZR',
        Montage: {
            '*': ['R48'],
        },
        Breite: {
            Value: 10,
            Unit: 'mm',
        },
        Id: 87819900,
        Bezeichnung: {
            DEde: 'Zugentlastungstrennsteg',
        },
    },
    {
        Dmin: {
            Value: 16,
            Unit: 'mm',
        },
        Leitungsdurchmesser: '16 - 18 mm',
        Hoehe: {
            Value: 54,
            Unit: 'mm',
        },
        Laengeneingabe: false,
        Leitungen: 1,
        ArtNrDE: 'CFX18.1',
        Montage: {
            '*': [
                'E332.25.2',
                'E332.32.2',
                'E332.50.2',
                'E332.75.2',
                'E333.25',
                'E333.32',
                'E333.50',
                'E333.75',
                'E331.25.2',
                'E331.32.2',
                'E331.50.2',
                'E331.75.2',
                '332.16',
                '332.32',
                '332.50',
                '332.75',
                '333.16',
                '333.32',
                '333.50',
                '333.75',
                '352.50',
                '353.50',
                '331.16',
                '331.32',
                '331.50',
                '331.75',
                '351.50',
                'E200',
                'E200.2',
                'Z200',
                'Z200.2',
                'E26',
                'E26.2',
                'E26.3',
                'Z26',
                'Z26.2',
                'Z26.3',
                'E300',
                'E300.2',
                'E300.3',
                'Z300',
                'Z300.2',
                'Z300.3',
                '1400',
                '1500',
                '2400',
                '2500',
                '2450',
                '2480',
                'R117',
                'R118',
                'R157',
                'R158',
                'R167',
                'R168',
                'R48',
                'R58.New',
                'R68.New',
                'E4.21',
                'E4.28',
                'R4.28',
                'E4.112',
                'E4.162',
                '800',
                '840',
                'E61.29',
                'EF61.29',
                'E61.35',
                'E6.29',
                'R6.29',
                'E6.35',
            ],
            KMA: [
                '2600',
                '2700',
                '2650',
                '2680',
                '3400',
                '3500',
                '3450',
                '3480',
                'E4.32',
                'H4.32',
                'R4.32',
                'E4.42',
                'H4.42',
                'R4.42',
                'E4.56',
                'H4.56',
                'R4.56',
                'E4.80',
                'H4.80',
                'R4.80',
                'E4.38L',
                'R4.38L',
                'E4.48L',
                'R4.48L',
                'E4.64L',
                '14040',
                '14140',
                'R18840',
                '14240',
                '14340',
                '14550',
                '14650',
                'R19050',
                '15050',
                '15150',
                'R19850',
                '15250',
                '15350',
                '1640',
                'R1608',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.40',
                'E6.52',
                'R6.52',
                'E6.62',
                'E6.80L',
                'E6.80',
            ],
        },
        Breite: {
            Value: 22,
            Unit: 'mm',
        },
        Id: 3119490700,
        Dmax: {
            Value: 18,
            Unit: 'mm',
        },
        Bezeichnung: {
            DEde: 'Standard-Bügelschelle, normaler Fuß, Stahl, einfach, mit Wannen',
        },
    },
    {
        Dmin: {
            Value: 30,
            Unit: 'mm',
        },
        Leitungsdurchmesser: '30 - 34 mm',
        Hoehe: {
            Value: 81,
            Unit: 'mm',
        },
        Laengeneingabe: false,
        Leitungen: 1,
        ArtNrDE: 'CFXL34.1',
        Montage: {
            '*': [
                '1400',
                '1500',
                '2400',
                '2500',
                '2450',
                '2480',
                '2600',
                '2700',
                '2650',
                '2680',
                '3400',
                '3500',
                '3450',
                '3480',
                'R117',
                'R118',
                'R157',
                'R158',
                'R167',
                'R168',
                'R48',
                'R58.New',
                'R68.New',
                'E4.21',
                'E4.28',
                'R4.28',
                'E4.32',
                'H4.32',
                'R4.32',
                'E4.42',
                'H4.42',
                'R4.42',
                'E4.56',
                'H4.56',
                'R4.56',
                'E4.80',
                'H4.80',
                'R4.80',
                'E4.112',
                'E4.162',
                '800',
                'E4.31L',
                'R4.31L',
                'E4.38L',
                'R4.38L',
                'E4.48L',
                'R4.48L',
                'E4.64L',
                '14040',
                '14140',
                'R18840',
                '14240',
                '14340',
                '14550',
                '14650',
                'R19050',
                '15050',
                '15150',
                'R19850',
                '15250',
                '15350',
                '1640',
                'R1608',
                'E61.29',
                'EF61.29',
                'E61.35',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.29',
                'R6.29',
                'E6.35',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.40',
                'E6.52',
                'R6.52',
                'E6.62',
                'E6.80L',
                'E6.80',
            ],
        },
        Breite: {
            Value: 38,
            Unit: 'mm',
        },
        Id: 5141065900,
        Dmax: {
            Value: 34,
            Unit: 'mm',
        },
        Bezeichnung: {
            DEde: 'Standard-Bügelschelle, breiter Fuß, Stahl, einfach, mit Wannen',
        },
    },
    {
        Dmin: {
            Value: 16,
            Unit: 'mm',
        },
        Leitungsdurchmesser: '16 - 20 mm',
        Laengeneingabe: false,
        Leitungen: 1,
        ArtNrDE: 'CFC-20-M',
        Montage: {
            '*': [
                'E332.25.2',
                'E332.32.2',
                'E332.50.2',
                'E332.75.2',
                'E333.25',
                'E333.32',
                'E333.50',
                'E333.75',
                'E331.25.2',
                'E331.32.2',
                'E331.50.2',
                'E331.75.2',
                '332.16',
                '332.32',
                '332.50',
                '332.75',
                '333.16',
                '333.32',
                '333.50',
                '333.75',
                '352.50',
                '353.50',
                '331.16',
                '331.32',
                '331.50',
                '331.75',
                '351.50',
                'E200',
                'E200.2',
                'Z200',
                'Z200.2',
                'E26',
                'E26.2',
                'E26.3',
                'Z26',
                'Z26.2',
                'Z26.3',
                'E300',
                'E300.2',
                'E300.3',
                'Z300',
                'Z300.2',
                'Z300.3',
                '1400',
                '1500',
                '2400',
                '2500',
                '2450',
                '2480',
                'R117',
                'R118',
                'R157',
                'R158',
                'R167',
                'R168',
                'R48',
                'R58.New',
                'R68.New',
                'E4.21',
                'E4.28',
                'R4.28',
                'E4.112',
                'E4.162',
                '800',
                '840',
                'E61.29',
                'EF61.29',
                'E61.35',
                'E6.29',
                'R6.29',
                'E6.35',
            ],
            KMA: [
                '2600',
                '2700',
                '2650',
                '2680',
                '3400',
                '3500',
                '3450',
                '3480',
                'E4.32',
                'H4.32',
                'R4.32',
                'E4.42',
                'H4.42',
                'R4.42',
                'E4.56',
                'H4.56',
                'R4.56',
                'E4.80',
                'H4.80',
                'R4.80',
                'E4.38L',
                'R4.38L',
                'E4.48L',
                'R4.48L',
                'E4.64L',
                '14040',
                '14140',
                'R18840',
                '14240',
                '14340',
                '14550',
                '14650',
                'R19050',
                '15050',
                '15150',
                'R19850',
                '15250',
                '15350',
                '1640',
                'R1608',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.40',
                'E6.52',
                'R6.52',
                'E6.62',
                'E6.80L',
                'E6.80',
            ],
        },
        Breite: {
            Value: 43.2,
            Unit: 'mm',
        },
        Id: 5822749900,
        Dmax: {
            Value: 20,
            Unit: 'mm',
        },
        Bezeichnung: {
            DEde: 'chainfix-Clips Bügel',
        },
    },
    {
        Dmin: {
            Value: 26,
            Unit: 'mm',
        },
        Leitungsdurchmesser: '26 - 30 mm',
        Hoehe: {
            Value: 77,
            Unit: 'mm',
        },
        Laengeneingabe: false,
        Leitungen: 1,
        ArtNrDE: 'CFXL30.1',
        Montage: {
            '*': [
                '1400',
                '1500',
                '2400',
                '2500',
                '2450',
                '2480',
                '2600',
                '2700',
                '2650',
                '2680',
                '3400',
                '3500',
                '3450',
                '3480',
                'R117',
                'R118',
                'R157',
                'R158',
                'R167',
                'R168',
                'R48',
                'R58.New',
                'R68.New',
                'E4.21',
                'E4.28',
                'R4.28',
                'E4.32',
                'H4.32',
                'R4.32',
                'E4.42',
                'H4.42',
                'R4.42',
                'E4.56',
                'H4.56',
                'R4.56',
                'E4.80',
                'H4.80',
                'R4.80',
                'E4.112',
                'E4.162',
                '800',
                'E4.31L',
                'R4.31L',
                'E4.38L',
                'R4.38L',
                'E4.48L',
                'R4.48L',
                'E4.64L',
                '14040',
                '14140',
                'R18840',
                '14240',
                '14340',
                '14550',
                '14650',
                'R19050',
                '15050',
                '15150',
                'R19850',
                '15250',
                '15350',
                '1640',
                'R1608',
                'E61.29',
                'EF61.29',
                'E61.35',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.29',
                'R6.29',
                'E6.35',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.40',
                'E6.52',
                'R6.52',
                'E6.62',
                'E6.80L',
                'E6.80',
            ],
        },
        Breite: {
            Value: 34,
            Unit: 'mm',
        },
        Id: 6880415900,
        Dmax: {
            Value: 30,
            Unit: 'mm',
        },
        Bezeichnung: {
            DEde: 'Standard-Bügelschelle, breiter Fuß, Stahl, einfach, mit Wannen',
        },
    },
    {
        Zaehne: 5,
        Laengeneingabe: false,
        ArtNrDE: '3050.ZC',
        Montage: {
            KMA: [
                '2600',
                '2700',
                '2650',
                '2680',
                '3400',
                '3500',
                '3450',
                '3480',
                'E4.32',
                'H4.32',
                'R4.32',
                'E4.42',
                'H4.42',
                'R4.42',
                'E4.56',
                'H4.56',
                'R4.56',
                'E4.80',
                'H4.80',
                'R4.80',
                'E4.38L',
                'R4.38L',
                'E4.48L',
                'R4.48L',
                'E4.64L',
                '14040',
                '14140',
                'R18840',
                '14240',
                '14340',
                '14550',
                '14650',
                'R19050',
                '15050',
                '15150',
                'R19850',
                '15250',
                '15350',
                '1640',
                'R1608',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.40',
                'E6.52',
                'R6.52',
                'E6.62',
                'E6.80L',
                'E6.80',
            ],
        },
        Breite: {
            Value: 50,
            Unit: 'mm',
        },
        Id: 6955989300,
        Bezeichnung: {
            DEde: 'Kettenkamm für C-Profil',
        },
    },
    {
        Dmin: {
            Value: 20,
            Unit: 'mm',
        },
        Leitungsdurchmesser: '20 - 24 mm',
        Laengeneingabe: false,
        Leitungen: 1,
        ArtNrDE: 'CFC-24-M',
        Montage: {
            '*': [
                'E332.25.2',
                'E332.32.2',
                'E332.50.2',
                'E332.75.2',
                'E333.25',
                'E333.32',
                'E333.50',
                'E333.75',
                'E331.25.2',
                'E331.32.2',
                'E331.50.2',
                'E331.75.2',
                '332.16',
                '332.32',
                '332.50',
                '332.75',
                '333.16',
                '333.32',
                '333.50',
                '333.75',
                '352.50',
                '353.50',
                '331.16',
                '331.32',
                '331.50',
                '331.75',
                '351.50',
                'E200',
                'E200.2',
                'Z200',
                'Z200.2',
                'E26',
                'E26.2',
                'E26.3',
                'Z26',
                'Z26.2',
                'Z26.3',
                'E300',
                'E300.2',
                'E300.3',
                'Z300',
                'Z300.2',
                'Z300.3',
                '1400',
                '1500',
                '2400',
                '2500',
                '2450',
                '2480',
                'R117',
                'R118',
                'R157',
                'R158',
                'R167',
                'R168',
                'R48',
                'R58.New',
                'R68.New',
                'E4.21',
                'E4.28',
                'R4.28',
                'E4.112',
                'E4.162',
                '800',
                '840',
                'E61.29',
                'EF61.29',
                'E61.35',
                'E6.29',
                'R6.29',
                'E6.35',
            ],
            KMA: [
                '2600',
                '2700',
                '2650',
                '2680',
                '3400',
                '3500',
                '3450',
                '3480',
                'E4.32',
                'H4.32',
                'R4.32',
                'E4.42',
                'H4.42',
                'R4.42',
                'E4.56',
                'H4.56',
                'R4.56',
                'E4.80',
                'H4.80',
                'R4.80',
                'E4.38L',
                'R4.38L',
                'E4.48L',
                'R4.48L',
                'E4.64L',
                '14040',
                '14140',
                'R18840',
                '14240',
                '14340',
                '14550',
                '14650',
                'R19050',
                '15050',
                '15150',
                'R19850',
                '15250',
                '15350',
                '1640',
                'R1608',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.40',
                'E6.52',
                'R6.52',
                'E6.62',
                'E6.80L',
                'E6.80',
            ],
        },
        Breite: {
            Value: 54,
            Unit: 'mm',
        },
        Id: 7456869500,
        Dmax: {
            Value: 24,
            Unit: 'mm',
        },
        Bezeichnung: {
            DEde: 'chainfix-Clips Bügel',
        },
    },
    {
        Dmin: {
            Value: 20,
            Unit: 'mm',
        },
        Leitungsdurchmesser: '20 - 22 mm',
        Hoehe: {
            Value: 58,
            Unit: 'mm',
        },
        Laengeneingabe: false,
        Leitungen: 1,
        ArtNrDE: 'CFX22.1.E',
        Montage: {
            '*': [
                'E332.25.2',
                'E332.32.2',
                'E332.50.2',
                'E332.75.2',
                'E333.25',
                'E333.32',
                'E333.50',
                'E333.75',
                'E331.25.2',
                'E331.32.2',
                'E331.50.2',
                'E331.75.2',
                '332.16',
                '332.32',
                '332.50',
                '332.75',
                '333.16',
                '333.32',
                '333.50',
                '333.75',
                '352.50',
                '353.50',
                '331.16',
                '331.32',
                '331.50',
                '331.75',
                '351.50',
                'E200',
                'E200.2',
                'Z200',
                'Z200.2',
                'E26',
                'E26.2',
                'E26.3',
                'Z26',
                'Z26.2',
                'Z26.3',
                'E300',
                'E300.2',
                'E300.3',
                'Z300',
                'Z300.2',
                'Z300.3',
                '1400',
                '1500',
                '2400',
                '2500',
                '2450',
                '2480',
                'R117',
                'R118',
                'R157',
                'R158',
                'R167',
                'R168',
                'R48',
                'R58.New',
                'R68.New',
                'E4.21',
                'E4.28',
                'R4.28',
                'E4.112',
                'E4.162',
                '800',
                '840',
                'E61.29',
                'EF61.29',
                'E61.35',
                'E6.29',
                'R6.29',
                'E6.35',
            ],
            KMA: [
                '2600',
                '2700',
                '2650',
                '2680',
                '3400',
                '3500',
                '3450',
                '3480',
                'E4.32',
                'H4.32',
                'R4.32',
                'E4.42',
                'H4.42',
                'R4.42',
                'E4.56',
                'H4.56',
                'R4.56',
                'E4.80',
                'H4.80',
                'R4.80',
                'E4.38L',
                'R4.38L',
                'E4.48L',
                'R4.48L',
                'E4.64L',
                '14040',
                '14140',
                'R18840',
                '14240',
                '14340',
                '14550',
                '14650',
                'R19050',
                '15050',
                '15150',
                'R19850',
                '15250',
                '15350',
                '1640',
                'R1608',
                'E61.40',
                'E61.52',
                'E61.62',
                'E61.80',
                'E6.40',
                'E6.52',
                'R6.52',
                'E6.62',
                'E6.80L',
                'E6.80',
            ],
        },
        Breite: {
            Value: 26,
            Unit: 'mm',
        },
        Id: 7503079900,
        Dmax: {
            Value: 22,
            Unit: 'mm',
        },
        Bezeichnung: {
            DEde: 'Standard-Bügelschelle, normaler Fuß, Edelstahl, einfach, mit Wannen',
        },
    },
];
//# sourceMappingURL=mockZugentlastungen.js.map